import { IRelativeWorkingInCourt } from "../../../model/report/applicantdata/RelativeWorkingInCourt";
import { IDebtObligation } from "../../../model/report/applicantdata/DebtObligation";
import { IReport8Applicant } from "../../../model/report/Report8Applicant";
import { IGiftAndDonation } from "../../../model/report/applicantdata/GiftAndDonation";
import { INonPaidActivity } from "../../../model/report/applicantdata/NonPaidActivity";
import { IAdditionalIncome } from "../../../model/report/applicantdata/AdditionalIncome";

export interface TReport8ApplicantPresentationModel {
  id: number;
  partyId: number;
  name: string;
  lastName: string;
}

export interface IReport8ApplicantPresentationModel
  extends TReport8ApplicantPresentationModel {
  relativesWorkingInCourt?: IRelativeWorkingInCourt[];
  additionalIncome?: IAdditionalIncome[];
  nonPaidActivities?: INonPaidActivity[];
  giftsAndDonations?: IGiftAndDonation[];
  debtObligations?: IDebtObligation[];
  fullName: string;
}

const Report8ApplicantPresentationModel = (
  data: IReport8Applicant
): IReport8ApplicantPresentationModel => {
  return {
    id: data.id,
    partyId: data.partyId,
    name: data.name,
    lastName: data.lastName,
    fullName: data.fullName,
    relativesWorkingInCourt: data.relativesWorkingInCourt,
    debtObligations: data.debtObligations,
    additionalIncome: data.additionalIncome,
    nonPaidActivities: data.nonPaidActivities,
    giftsAndDonations: data.giftsAndDonations
  };
};

export default Report8ApplicantPresentationModel;
